module.exports = __webpack_public_path__ + "images/icon/icn_searchhistory_16x16-31c4a505.svg";